import { getMainSiteUrl } from '@/lib/domain';

/**
 * Normalise une URL de média stockée en base.
 *
 * Beaucoup de logos/identités historiques sont enregistrés comme de simples
 * noms de fichiers relatifs (ex. « 17792705013962.png » ou
 * « images/imageaboutus/xxx.jpg »). Ces chemins ne sont pas résolvables tels
 * quels dans une balise <img> et le logo n'apparaît donc jamais sur le site
 * public. On les transforme ici en URL absolue.
 *
 * Les valeurs déjà absolues (http/https, data:, blob:, //cdn…) sont renvoyées
 * telles quelles.
 */
export function resolveMediaUrl(value?: string | null): string {
  const raw = (value || '').trim();
  if (!raw) return '';
  if (/^(https?:)?\/\//i.test(raw)) return raw;
  if (/^(data|blob):/i.test(raw)) return raw;

  // Chemin relatif historique → racine du site principal Zifek.
  return `${getMainSiteUrl()}/${raw.replace(/^\/+/, '')}`;
}